import { render, staticRenderFns } from "./LeaseAuthImage.vue?vue&type=template&id=edda4cf8&scoped=true&"
import script from "./LeaseAuthImage.vue?vue&type=script&lang=js&"
export * from "./LeaseAuthImage.vue?vue&type=script&lang=js&"
import style0 from "./LeaseAuthImage.vue?vue&type=style&index=0&id=edda4cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edda4cf8",
  null
  
)

export default component.exports